export default {
  panel: {},
  transfer: {},
  popover: {},
};
